<template>
<div class="chapter">
<div class="inner_page">
<div style="page-break-before: always;"></div>
<h1 class="P_Heading_1__And__Page_Break" id="auto_bookmark_toc_1"><span>Acknowledgments</span></h1>
<p class="P_Normal"> </p>
<p class="P_Normal"> </p>
<p class="P_Normal__And__Left_Indent"><span style=" font-size: 1.17em;">THERE ARE</span> so many people I have to thank for getting my books out, I’m always afraid to forget somebody. As always, I have to thank my family, who puts up with my strange moods when the story isn’t going the way I want it to. My cat for sitting next to me, purring and snoring, kindly reminding me there is at least one family member that doesn’t do anything productive at all and doesn’t feel bad about it. My horse for not being productive either but keeping me from work. My editors, Anne Regan, Kelly, Liv, and Anastasia for patiently correcting my logical and grammatical mistakes and for attaching nice comments to the MS that keep me from getting depressed. And, of course, my readers. You are the reason I’m doing this. Thank you!</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0004.vue?151a6550